import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as FCORREL from './fcorrel.res.js'

function getMclassName(inData) {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    return inData['workers'][mclassindex]
}

function setFactorCtrl(curChart, inData, region) {
    const chartName = 'factorCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: FCORREL.CHART_CORREL_FACTORS,
        rectMain: curRect

    }
    FCORREL.clearFactors()
    FCORREL.setFactorsTitle('因子集(' + inData['factors'].datas.length + ')')
    
    const mclassname = getMclassName(inData)

    for (let index = 0; index < inData['factors'].datas.length; index++) {
        FCORREL.incrFactors(CLAPI.getData(inData['factors'], 'name', index))
    }

    curCfg.config.selectIndex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
    // console.log(curCfg.config.selectIndex);
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'factorindex', result.selectIndex)
            drawFCorrel(inData, false)
            // onLoad()
        }
    })
}
function setMclassCtrl(curChart, inData, region) {
    const chartName = 'mclassCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FCORREL.CHART_CORREL_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    
    curCfg.config.selectIndex = mclassindex;
    
    chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
            onClassLoad(inData)
        }
    })
}
function setMinuteCtrl(curChart, inData, region) {
    const chartName = 'minuteCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FCORREL.CHART_CORREL_MINUTE,
        rectMain: curRect

    }
    const mclassname = getMclassName(inData)

    let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), inData['minutes'].length)
    
    curCfg.config.selectIndex = minuteindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'minuteindex', result.selectIndex)
            // onLoadData(inData, true)
            onClassLoad(inData)
        }
    })
}

function setCorrelChart(curChart, inData, region) {
    const chartName = 'CorrelChart'
    const chart = curChart.getChart(chartName)

    const vdatas = FCORREL.ToWCorrel(inData['fcorrel'], inData['factors'].datas.length)
    
    const curRect = CLAPI.getChartRect(region, 1, 1, 0, 0)
    // console.log(curRect, region);
    // console.log(JSON.stringify(vdatas));
    // 设置界面信息和绑定数据
    const curCfg = {
        config: {
                title: {
                    display : 'normal',
                    label: '相关热力图',
                },
            },
        cellnames: DATAS.extractField(inData['factors'], 'name'),
        cellinfos: vdatas,
        rectMain: curRect
    }
    // console.log(JSON.stringify(curCfg.cellnames)); 
    // Init.setUserInfo('FVerify', 'factorindex', result.selectIndex)
    // console.log(curCfg);
    // 其他为辅助数据 实际运算时
    chart.createChart(chartName, 'system.mheat', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log('main', result)
        if (result.event === 'btndown') {
            const leftchart = curChart.getUserChart('factorCtrl', 'factorCtrl')
            leftchart.changeSelectIndex(result.selectIndex)
        }
    })
    
}

function drawFCorrel(inData, isFirst) {

    console.log('Draw ====> FCorrel Line')
    // console.log(JSON.stringify(inData));
    // console.log(inData);

    const curChart = Init.getSysChart()

    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['CorrelChart', 'mclassCtrl', 'minuteCtrl', 'factorCtrl'])

        const canvas = Init.canvas
        const left = FCORREL.FWIDTH * Init.scale
        const head = 25 * Init.scale
        // 设置顶部窗口
        setMclassCtrl(curChart, inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: canvas.width,
            height: head,
        })

        const high = canvas.height - head
        // 设置左部窗口
        setFactorCtrl(curChart, inData, {
            style: 'sidebar',
            top: head,
            left: 0,
            width: left,
            height: high,
        })
        const mainW = (canvas.width - left)
        // 设置分钟窗口
        setMinuteCtrl(curChart, inData, {
            style: 'sidebar',
            top: head,
            left: left,
            width: mainW,
            height: head - Init.scale,
        })
        // 设置第一个窗口
        setCorrelChart(curChart, inData, {
            style: 'average',
            top: head + head,
            left: left,
            width: mainW,
            height: high - head,
        })
    }

    curChart.onPaint()
}

export function onClassLoad(inData) {
    
    const mclassname = getMclassName(inData)
    let minutes = [] 
    function onInit() {
        let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), minutes.length)
        Init.sendCommand({
                cmds: {
                    "factors": {
                        "cmd": "get",
                        "subject": "CN000000.factors",
                        "service": inData.modulepath + '/' + mclassname + "/correl_" + minutes[minuteindex],
                        "info": {
                            "offset": 0,
                        }
                    },
                    "fcorrel": {
                        "cmd": "get",
                        "subject": "CN000000.factor_wcorrel",
                        "service": inData.modulepath + '/' + mclassname + "/correl_" + minutes[minuteindex],
                        "info": {
                            "offset": 0,
                        }
                    }
                }
            },
            function reply(datas) {
                // console.log(datas)
                if (Init.checkDatas(datas)) {
                    inData['minutes'] = minutes
                    inData['factors'] = datas['factors']
                    inData['fcorrel'] = datas['fcorrel']
                    drawFCorrel(inData, true)
                }
            });
        }
    Init.sendCommand({
                cmds: {
                    "minutes": {
                        "cmd": "files",
                        "service": inData.modulepath + '/' + mclassname + "/*.mdb"
                    }
                }
            },
            function reply(datas) {
                console.log(mclassname, datas)
                if (Init.checkDatas(datas)) {
                    // 这里更新分钟数据
                    datas['minutes'].datas.sort((a,b) => b[1].localeCompare(a[1]))
    
                    for (let index = 0; index < datas['minutes'].datas.length; index++) {
                        let fname = datas['minutes'].datas[index][1];
                        minutes.unshift(fname.split('_')[1].split('.')[0]);
                    }
                    FCORREL.onInit(inData['workers'], minutes)
                    console.log(inData['workers'], minutes)
                    onInit()
                }
            });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'normal'
    inData.modulepath = argvs.modulepath ?? 'fcorrel'

    Init.sendCommand({
            cmds: {
                "workers": {
                    "cmd": "paths",
                    "service": inData.modulepath + '/'
                }
            }
        },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                // 这里更新分钟数据
                inData['workers'] = []
                for (let index = 0; index < datas['workers'].datas.length; index++) {
                    inData['workers'].push(CLAPI.getData(datas['workers'], 'pathname', index))
                }
                onClassLoad(inData)
            }
        });
}
// 注册方法到参数表